import {
  SpacingName, ThemedFunctor, getSpacing, BreakpointQueryName,
} from '@doveit/bricks';
import { css } from 'styled-components';

export const offerBox: ThemedFunctor = ({ theme }) => css`
  ${getSpacing.padding(theme, [SpacingName.SMALL, 0])}
  text-align: center;
`;

export const columnDivider: ThemedFunctor = ({ theme }) => css`
  border-bottom: 1px solid ${theme.palettes.neutrals.light};

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    border-bottom: none;
    border-right: 1px solid ${theme.palettes.neutrals.light};
  }
`;
